import { TDocumentType } from '@/@types/document-type';
import { Modal } from '@/components/common';
import { Close } from '@mui/icons-material';
import { DialogTitle, IconButton, LinearProgress } from '@mui/material';
import { DocumentTypeForm, DocumentTypeFormData } from '../DocumentTypeForm';
import { DocumentTypeFormPlaceholder } from '../DocumentTypeForm/DocumentTypeFormPlaceholder';

interface IDocumentTypeModalProps {
  documentType?: TDocumentType;
  isOpen: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: DocumentTypeFormData) => void;
}

export function DocumentTypeModal({
  documentType,
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  isSubmitting,
}: IDocumentTypeModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle id="scroll-dialog-title" sx={{ p: 2 }}>
        {documentType ? 'Alterar Tipo de Documento' : 'Novo Tipo de Documento'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {isSubmitting ? <LinearProgress /> : null}
      {isLoading ? (
        <DocumentTypeFormPlaceholder />
      ) : (
        <DocumentTypeForm
          documentType={documentType}
          isLoading={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      )}
    </Modal>
  );
}
